export class OrgResponseViewModel {
  SSN: string;
  InsuranceType: string;
}
